// httpPorts — the Landing slice: how a module or course lands in its
// format, and "Move it" on a proposal, over the command bus. Every reply is
// parsed at this boundary.

import { Result } from "@bilda/utils";
import { mkMalformed } from "../externalError.js";
import { landingFormatId, parseLanding } from "../landingAdapter.js";
import type { LandingPorts } from "../ports/landing.js";
import { fields, num } from "../wireShape.js";
import { command } from "./shared.js";

export const landingHttp: LandingPorts = {
    loadHowItLands: async (containerId, format) => {
        const r = await command("howItLands", {
            containerId,
            format: landingFormatId(format),
        });
        return Result.isErr(r) ? r : parseLanding(r.value);
    },
    moveTextIntoPart: async ({ container, blocks, part }) => {
        const r = await command("moveTextIntoPart", {
            container,
            blocks,
            part,
        });
        if (Result.isErr(r)) return r;
        const moved = num(fields(r.value)?.get("moved"));
        return moved === undefined
            ? Result.err(mkMalformed("moveTextIntoPart: no count"))
            : Result.ok(moved);
    },
};
